$(document).ready(function() {
            $("a[href^='#product_Specifications_details_tab']").click(function(e) {
              e.preventDefault();
              var position = $("#product_Specifications_details_tab").offset().top - 200;
              $("body, html").animate({
                scrollTop: position
              } ,500 );
            //   var isExpandedFirst = $('.product_specifications_details_tab_action').attr('aria-expanded'); 
            //   if(isExpandedFirst == 'false')
            //   {
            //      $(this).addClass("active");
            //      $("#product_Specifications_details_tab .accordion__title").click();
            //   }
            //   var isExpandedSecond = $('.product_specifications_details_tab2_action').attr('aria-expanded'); 
            //   if(isExpandedSecond == 'false')
            //   {
            //      $(this).addClass("active");
            //      $("#product_Specifications_details_tab2 .accordion__title").click();
            //   }
            //   var isExpandedThird = $('.product_specifications_details_tab3_action').attr('aria-expanded'); 
            //   if(isExpandedThird == 'false')
            //   {
            //      $(this).addClass("active");
            //      $("#product_Specifications_details_tab3 .accordion__title").click();
            //   }
            });          
});
$(document).ready(function() {
            $(".custom-pdp-variant-colour-option").click(function(e) {
              var custom_pdp_variant_colour_option_content = $(this).attr("value");
              $(".custom-pdp-variant-colour-option-content").html('<span class="dots">:</span>'+custom_pdp_variant_colour_option_content);
            });          
});

const equalHeight = ($ele) => {
  let cacheHeight = 0;
  setTimeout(() => {
    let ele = document.querySelectorAll($ele);
    ele.forEach(element => {
      (element.clientHeight > cacheHeight) ? cacheHeight = element.clientHeight : cacheHeight = cacheHeight;
    });
    ele.forEach(element => {
      element.style.height = `${cacheHeight}px`
    })
  }, 200);
}
document.addEventListener("DOMContentLoaded", (event) => {
  equalHeight('.compare-products .compare-product-head-wrapper');
  equalHeight('.compare-products .price');
  equalHeight('.compare-products .color');
  equalHeight('.compare-products .warranty');
  equalHeight('.compare-products .suitable');
  equalHeight('.compare-products .age-bassinet');
  equalHeight('.compare-products .age-seat');
  equalHeight('.compare-products .number-of-child');
  equalHeight('.compare-products .capsule');
  equalHeight('.compare-products .compatible');
  equalHeight('.compare-products .pram-chassis');
  equalHeight('.compare-products .Newborn_bassinet');
  equalHeight('.compare-products .Toddler_seat');
  equalHeight('.compare-products .Accessories_included');
  equalHeight('.compare-products .aluminium_chassis');
  equalHeight('.compare-products .Puncture-proof_gel');
  equalHeight('.compare-products .Exterior_materials');
  equalHeight('.compare-products .Interior_materials');
  equalHeight('.compare-products .front_swivel_wheels');
  equalHeight('.compare-products .Adjustable_handlebar_top_height');
  equalHeight('.compare-products .Central_foot-operated_brake');
  equalHeight('.compare-products .World_or_parent-facing_options');
  equalHeight('.compare-products .Fold_type');
  equalHeight('.compare-products .Suspension');
  equalHeight('.compare-products .Front_impact_shock_absorbers');
  equalHeight('.compare-products .Removable_washable_linings');
  equalHeight('.compare-products .Purchase_basket_capacity');
  equalHeight('.compare-products .Storage_pockets');
  equalHeight('.compare-products .Airvents');
  equalHeight('.compare-products .Bassinet_carry');
  equalHeight('.compare-products .Bassinet_sit');
  equalHeight('.compare-products .Comfort180');
  equalHeight('.compare-products .Seat_safety_harness');
  equalHeight('.compare-products .Seat_adjustable_footrest');
  equalHeight('.compare-products .Table_height_seat_for_dining_out');
  equalHeight('.compare-products .Seat_Bumper_bar_adjustment');
  equalHeight('.compare-products .Seat_adjustable_hoods');
  equalHeight('.compare-products .Bassinet_weight');
  equalHeight('.compare-products .Seat_weight');
  equalHeight('.compare-products .Chassis_weight');
  equalHeight('.compare-products .Chassis_and_seat_combined_weight');
  equalHeight('.compare-products .Chassis_folded_with_seat_dimensions');
  equalHeight('.compare-products .Chassis_folded_without_seat_dimensions');
  equalHeight('.compare-products .Supervised_sleeping_approved');
  equalHeight('.compare-products .Night_stand_available');
  equalHeight('.compare-products .Buggy_board_compatable');
  equalHeight('.compare-products .Safety_Standard capsule'); 
  equalHeight('.compare-products .bundel_btn'); 
  equalHeight('.compare-products .pdp_link'); 
});


const transparentHeader = document.querySelector('.main-banner-wrapper');
if(transparentHeader){
  if(transparentHeader.classList.contains('transparent-header')){
   document.body.classList.add('transparent-header-overlay');
 }
}

var swiper = new Swiper(".compare-product-slider", {
  slidesPerView: 1,
  spaceBetween: 26,
  grabCursor: true,
  freeMode: true,
  
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 1.6,
      spaceBetween: 26,
    },
    1024: {
      slidesPerView: 2.6,
      spaceBetween: 26,
    },
    1300: {
      slidesPerView: 3.6,
      spaceBetween: 26,
    },
  },
});

document.querySelectorAll(".close-icon").forEach(function(closeIcon) {
  closeIcon.addEventListener("click", function() {
    var closeId = this.dataset.closeId;
    var element = document.getElementById(closeId);
    if (element) {
      element.classList.add("tab-section-hide");
      // Remove active class from corresponding tab data
      var tabData = document.querySelector(".tab-data[data-tabid='" + closeId + "']");
      if (tabData) {
        tabData.classList.add("active");
      }
    }
  });
});

document.querySelectorAll(".tab-data").forEach(function(tabData) {
  tabData.addEventListener("click", function() { 
    var tabId = this.dataset.tabid; 
    var element = document.getElementById(tabId);
    if (element) {
      element.classList.remove("tab-section-hide");
        tabData.classList.remove("active");
    }
  });
});


var clearAllBtn = document.querySelector(".clear-all");

if (clearAllBtn) {
  clearAllBtn.addEventListener("click", function() {
    var elements = document.querySelectorAll(".compare-product.swiper-slide");
    var elementsTwo = document.querySelectorAll(".tab-data");

    elements.forEach(function(element) {
      element.classList.add("tab-section-hide");
    });

    elementsTwo.forEach(function(element) {
      element.classList.add("active");
    });
  });
}

var showAllBtn = document.querySelector(".show-all");

if (showAllBtn) {
  showAllBtn.addEventListener("click", function() {
    var elements = document.querySelectorAll(".compare-product.swiper-slide");
    var elementsTwo = document.querySelectorAll(".tab-data");

    elements.forEach(function(element) {
      element.classList.remove("tab-section-hide");
    });

    elementsTwo.forEach(function(element) {
      element.classList.remove("active");
    });
  });
}


// document.addEventListener('DOMContentLoaded', () => {
//     // Height of the sticky header
//     const stickyHeaderHeight = 65;

//     // Function to check if an element is vertically visible in the viewport
//     const isVerticallyNearHidden = (element) => {
//         const rect = element.getBoundingClientRect();
//         const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
//         // Check if the element is within the sticky header height from the top of the viewport
//         return rect.top < viewportHeight - stickyHeaderHeight && rect.bottom > 0;
//     };

//     const cpTitleWrappers = document.querySelectorAll('.cp-title-wrapper');
//     const stickyTitleWrappers = document.querySelectorAll('.sticky-title-wrapper');

//     const observer = new IntersectionObserver((entries) => {
//         entries.forEach(entry => {
//             if (!entry.isIntersecting) {
//                 if (!isVerticallyNearHidden(entry.target)) {
//                     stickyTitleWrappers.forEach(stickyTitleWrapper => {
//                         stickyTitleWrapper.classList.add('sticky');
//                         stickyTitleWrapper.style.display = 'block';
//                         stickyTitleWrapper.style.top = `${stickyHeaderHeight}px`; // Initial top position
//                     });
//                 }
//             } else {
//                 stickyTitleWrappers.forEach(stickyTitleWrapper => {
//                     stickyTitleWrapper.classList.remove('sticky');
//                     stickyTitleWrapper.style.display = 'none';
//                 });
//             }
//         });
//     }, { threshold: [0] });

//     window.addEventListener('scroll', () => {
//         stickyTitleWrappers.forEach(stickyTitleWrapper => {
//             if (stickyTitleWrapper.classList.contains('sticky')) {
//                 const scrollTop = window.scrollY || document.documentElement.scrollTop;
//                 stickyTitleWrapper.style.top = `${scrollTop - 385}px`;
//             }
//         });
//     });

//     stickyTitleWrappers.forEach(stickyTitleWrapper => {
//         stickyTitleWrapper.style.display = 'none';
//     });

//     cpTitleWrappers.forEach(cpTitleWrapper => {
//         observer.observe(cpTitleWrapper);
//     });
// });

document.addEventListener('DOMContentLoaded', function() {
    const targetElements = document.querySelectorAll('.cp-title-wrapper');
    const stickyClass = 'sticky'; // Define your sticky class
   function getNavHeight() {
        const windowWidth = window.innerWidth;
        return windowWidth <= 750 ? 45 : 65; // If width is 750px or less, set navHeight to 50, otherwise 67
    }

    function handleScroll() {
        const navHeight = getNavHeight(); // Get dynamic nav height based on window width
        targetElements.forEach(targetElement => {
            const productWrap = targetElement.closest('.product-wrap');
            if (!productWrap) return; // Skip if no parent product-wrap found

            const productWrapRect = productWrap.getBoundingClientRect();
            const elementRect = targetElement.getBoundingClientRect();

            // Calculate the initial top offset of the element within its parent container
            const initialTopOffset = 300;

            // Calculate the scroll position
            const scrollPosition = window.scrollY;

            // Calculate the top position of the element relative to the viewport
            const productWrapTop = productWrapRect.top + scrollPosition;

            if (scrollPosition > (productWrapTop + initialTopOffset)) {
                targetElement.classList.add(stickyClass);
                targetElement.classList.add("sticky-title-wrapper");
                // Adjust the top position considering the navigation height
                targetElement.style.top = `${scrollPosition - productWrapTop + navHeight}px`;
            } else {
                targetElement.classList.remove(stickyClass);
                targetElement.classList.remove("sticky-title-wrapper");
                targetElement.style.top = ''; // Reset top position when not sticky
            }
        });
    }

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Initial check in case the elements are already out of view on page load
    handleScroll();
});


document.addEventListener('DOMContentLoaded', function () {
  function getSelectedVariantName() {
    const checkedRadio = document.querySelector('variant-radios input[type="radio"]:checked');
    if (checkedRadio) return checkedRadio.value.trim().toLowerCase();

    const selectedOption = document.querySelector('variant-selects select option:checked');
    if (selectedOption) return selectedOption.text.trim().toLowerCase();

    return null;
  }

  function getMediaAltText(mediaItem) {
    const media =
      mediaItem.querySelector('img') ||
      mediaItem.querySelector('video') ||
      mediaItem.querySelector('[alt]');

    if (!media) return '';
    return (media.getAttribute('alt') || '').trim().toLowerCase();
  }

  function filterVariantMedia() {
    const variantName = getSelectedVariantName();
    if (!variantName) return;

    const mediaItems = document.querySelectorAll('.product__media-item[data-media-id]');
    const thumbnailItems = document.querySelectorAll('.thumbnail-list__item[data-target]');

    let firstMatchingThumbnail = null;
    let firstMatchingMediaId = null;

    mediaItems.forEach(function (item) {
      const altText = getMediaAltText(item);

      const isMatch = altText.includes(variantName);

      if (isMatch) {
        item.removeAttribute('hidden');
        item.style.display = '';
        item.classList.remove('variant-media-hidden');

        if (!firstMatchingMediaId) {
          firstMatchingMediaId = item.getAttribute('data-media-id');
        }
      } else {
        item.setAttribute('hidden', 'hidden');
        item.style.display = 'none';
        item.classList.add('variant-media-hidden');
      }
    });

    thumbnailItems.forEach(function (thumb) {
      const targetId = thumb.getAttribute('data-target');
      const matchingMedia = document.querySelector('.product__media-item[data-media-id="' + targetId + '"]');

      if (matchingMedia && !matchingMedia.classList.contains('variant-media-hidden')) {
        thumb.removeAttribute('hidden');
        thumb.style.display = '';
        thumb.classList.remove('variant-media-hidden');

        if (!firstMatchingThumbnail && targetId === firstMatchingMediaId) {
          firstMatchingThumbnail = thumb;
        }
      } else {
        thumb.setAttribute('hidden', 'hidden');
        thumb.style.display = 'none';
        thumb.classList.add('variant-media-hidden');
      }
    });

    if (firstMatchingThumbnail) {
      const thumbButton = firstMatchingThumbnail.querySelector('button, img, a');
      if (thumbButton && typeof thumbButton.click === 'function') {
        thumbButton.click();
      }
    }

    window.dispatchEvent(new Event('resize'));
  }

 if (typeof filterVariantMedia === 'function') {
  setTimeout(filterVariantMedia, 50);
}

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('variant-radios input[type="radio"]') ||
      event.target.matches('variant-selects select') ||
      event.target.matches('input[name="Color"]') ||
      event.target.matches('input[name="Colour"]')
    ) {
      if (typeof filterVariantMedia === 'function') {
  setTimeout(filterVariantMedia, 50);
}
    }
  });

  document.addEventListener('shopify:section:load', function () {
    if (typeof filterVariantMedia === 'function') {
  setTimeout(filterVariantMedia, 50);
}
  });
});
// If product only has one variant, force gallery filtering
var variantInputs = document.querySelectorAll('variant-radios input[type="radio"], variant-selects select');

if (variantInputs.length <= 1) {
  if (typeof filterVariantMedia === 'function') {
  setTimeout(filterVariantMedia, 50);
}
}
